
import {defineComponent, unref} from 'vue';

export default defineComponent({
  name: 'oxd-report-table-multiline-cell',
  props: {
    rowIndex: {
      type: Number,
    },
    prop: {
      type: String,
    },
    model: {},
  },
  setup(props) {
    const data = unref(props.model[props.prop]);
    const items = Array.isArray(data)
      ? data.map(i => {
          return {content: i, _id: props.rowIndex};
        })
      : [];

    return {
      items,
    };
  },
});
